import { render, staticRenderFns } from "./PurchasePlan.vue?vue&type=template&id=1b569860&scoped=true&"
import script from "./PurchasePlan.vue?vue&type=script&lang=js&"
export * from "./PurchasePlan.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlan.vue?vue&type=style&index=0&id=1b569860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b569860",
  null
  
)

export default component.exports